exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.action[data-v-064f6ce4]{margin-right:5px!important}i.big[data-v-064f6ce4]{font-size:2em}.badge[data-v-064f6ce4]{padding:.4em .8em}table[data-v-064f6ce4]{font-size:.9em}th.ore[data-v-064f6ce4]{background-color:rgba(0,0,0,.135)}td.ore[data-v-064f6ce4],th.ore[data-v-064f6ce4]{text-align:center}td.ore[data-v-064f6ce4]{background-color:rgba(0,0,0,.035)}td.ore.total[data-v-064f6ce4]{background-color:rgba(0,0,0,.135)}.btn-green[data-v-064f6ce4],.btn-green[data-v-064f6ce4]:active,.btn-green[data-v-064f6ce4]:focus{background-color:#38c172!important;border-color:#38c172!important}textarea.notes[data-v-064f6ce4]{resize:none}", ""]);

// exports
